import React from 'react';
import { PageHeader } from '@insurancemenu/imenu-components-lib';
import { observer } from 'mobx-react-lite';
import ActionModal from '@insurancemenu/imenu-components-lib/dist/components/modals/ActionModal';
import { PageHeaderProps } from '@insurancemenu/imenu-components-lib/dist/types/layouts/PageHeader';
import { ModalType } from '@insurancemenu/imenu-components-lib/dist/helpers/ModalsHelper';
import SafeguardModalDelegate from 'store/general/safeguardModalDelegate';

export interface SafeguardPageHeaderProps extends PageHeaderProps {
  saveChangesModalDelegate: SafeguardModalDelegate;
  noSavingExitModalDelegate: SafeguardModalDelegate;
}

const SafeguardPageHeader: React.FC<SafeguardPageHeaderProps> = observer(
  ({ saveChangesModalDelegate, noSavingExitModalDelegate, ...props }) => {
    return (
      <>
        <PageHeader {...props} />
        <ActionModal
          show={saveChangesModalDelegate.isVisible}
          onClose={saveChangesModalDelegate.onClose || saveChangesModalDelegate.close}
          onAction={saveChangesModalDelegate.onAction}
          closeButtonText="Exit Without Saving"
          actionButtonText="Save Changes"
          title="Would you like to save your changes before exiting?"
          modalType={ModalType.NOTIFICATION}
          closable={false}
        />
        <ActionModal
          show={noSavingExitModalDelegate.isVisible}
          onClose={noSavingExitModalDelegate.onAction}
          onAction={noSavingExitModalDelegate.close}
          closeButtonText="Exit Without Saving"
          actionButtonText="Stay on this page"
          title="Would you like to exit without saving your changes?"
          modalType={ModalType.NOTIFICATION}
          closable={false}
        />
      </>
    );
  },
);

export default SafeguardPageHeader;
